/* eslint-disable no-restricted-globals */
/* eslint-disable class-methods-use-this */

'use strict';

import ProductDetailEMEA from 'falcon/components/product/ProductDetailEMEA';
import { isEmpty } from 'lodash';

var scrollAnimate = require('org/components/scrollAnimate');
var util = require('org/util');
var savedItem = true;
var productId;
var isVisible = require('org/components/isVisible');
var freeShippingBar = require('org/components/cart/FreeShippingBar');


export default class ProductDetail extends ProductDetailEMEA {
    init() {
        super.init();
        $(window).on('load', this.checkUARProductInURL.bind(this));
        $(window).on('load', this.checkWishlistVariationInURL.bind(this));
    }

    /**
    * Function to select variation attributes values from subsequent params appended in URL and add product to cart. After selection of the attributes removing the params from URL.
    */
    checkUARProductInURL() {
        if ($('.js-login').length === 0 && !(util.getCookie('showCompleteAccountModal') === 'true') && ($('.pdp-mobile-auth').length === 0 || $('.pdp-mobile-auth').attr('data-mobileauth-enabled') !== 'true' || $('.pdp-mobile-auth').attr('data-mobileauth-pending') !== 'true')) { // check if mobile authentication is pending
            var urlParams = new URLSearchParams(window.location.search);
            var triggerATC = urlParams.has('triggerATC');
            if (triggerATC && $('.uar-product').length) {
                var $uarBlock = $('.uar-product');
                const self = this;
                var splitSizesLookup;
                var selectedVariation;
                var size1;
                var size2;
                if ($('.sizeSplit').length > 0) {
                    splitSizesLookup = JSON.parse($('.sizeSplit', this.$el).attr('data-split-lookup'));

                    var size = $uarBlock.data('size');
                    if (urlParams.has('gender')) {
                        size1 = urlParams.get('gender');
                        Object.keys(splitSizesLookup.first[size1]).forEach((secondKey) => {
                            if (!selectedVariation && splitSizesLookup.first[size1][secondKey].value === size) {
                                selectedVariation = splitSizesLookup.first[size1][secondKey];
                            }
                        });
                        if (size1 === 'men') {
                            size2 = selectedVariation.splitValue[1];
                        } else {
                            size2 = selectedVariation.splitValue[2];
                        }
                    } else {
                        Object.keys(splitSizesLookup.first).forEach((firstKey) => {
                            if (!selectedVariation) {
                                Object.keys(splitSizesLookup.first[firstKey]).forEach((secondKey) => {
                                    if (!selectedVariation && splitSizesLookup.first[firstKey][secondKey].value === size) {
                                        selectedVariation = splitSizesLookup.first[firstKey][secondKey];
                                        size1 = firstKey;
                                        size2 = secondKey;
                                    }
                                });
                            }
                        });
                    }
                }
                $('.b-product_attrs-item.variation_attr').each(function (index) {
                    var varAttr = $(this).attr('data-attr');
                    if (varAttr === 'color') {
                        return;
                    }
                    if (varAttr === 'size' && ($(this).attr('data-split-attr') === 'size1' || $(this).attr('data-split-attr') === 'size2')) {
                        varAttr = $(this).attr('data-split-attr');
                    }
                    var varAttrVal = $uarBlock.data(varAttr);
                    if (varAttr === 'size2') {
                        varAttrVal = size2;
                    }
                    var valLink;
                    if (varAttr === 'size1') {
                        self.processSplitSizeValues(splitSizesLookup, size1, null);
                    } else if (typeof varAttrVal === 'number' || !isEmpty(varAttrVal)) {
                        valLink = $(this).find('ul li a[data-attr-value="' + varAttrVal + '"]');
                        if ((!isEmpty(valLink))) {
                            if ($(this).find('ul li a.selected').length > 0) {
                                $(this).find('ul li a.selected').removeClass('selected m-active');
                            }
                            valLink.addClass('selected');
                            if (index === $('.b-product_attrs-item.variation_attr').length - 1) {
                                window.triggerATC = true; // trigger ATC after all attributes are selected
                                if ($('.sizeSplit').length > 0) {
                                    let valUrl = selectedVariation.url;

                                    let splitValues = { first: size1, second: size2 };
                                    if (urlParams.has('uarQty')) {
                                        let quantityValue = urlParams.get('uarQty');
                                        let urlObj = new URL(valUrl);
                                        urlObj.searchParams.set('quantity', quantityValue || 1);
                                        valUrl = urlObj.toString();
                                    }
                                    self.attributeSelect({
                                        option: varAttr,
                                        value: size2,
                                        valueUrl: valUrl,
                                        splitValues: splitValues
                                    });
                                } else {
                                    let valUrl = valLink.closest('li').attr('data-url');
                                    if (urlParams.has('uarQty')) {
                                        let quantityValue = urlParams.get('uarQty');
                                        let urlObj = new URL(valUrl);
                                        urlObj.searchParams.set('quantity', quantityValue || 1);
                                        valUrl = urlObj.toString();
                                    }
                                    self.attributeSelect({
                                        option: varAttr,
                                        value: varAttrVal,
                                        valueUrl: valUrl
                                    });
                                }
                            }
                        }
                    }
                });
                if (urlParams.has('uarProductID')) {
                    var uarPidValue = urlParams.get('uarProductID');
                    $('.l-pdp.product-detail').data('pid', uarPidValue);
                }
                urlParams.delete('uarProductID');
                urlParams.delete('triggerATC');
                urlParams.delete('uarQty');
                urlParams.delete('gender');
                var hash = '';
                if (window.location.href.indexOf('#') !== -1) {
                    hash = '#' + window.location.href.split('#')[1];
                }
                var url = window.location.pathname + '?' + urlParams.toString() + hash;
                history.replaceState({}, '', url);
            }
        }
    }

    /**
    * Restores variation attributes saved to the URL by the wishlist gate, so
    * the PDP loads with the colour and size the customer had selected before
    * being prompted to authenticate. Mirrors checkUARProductInURL, which does
    * the same for the member-price feature (SFCC-7415).
    *
    * When the variations are re-selected via attributeSelect, the AJAX
    * response carries isItemExistsInWishList for the restored variant, so the
    * heart is filled automatically if the save continuation has already
    * completed.
    */
    checkWishlistVariationInURL() {
        if ($('.js-login').length === 0 && !(util.getCookie('showCompleteAccountModal') === 'true') && ($('.pdp-mobile-auth').length === 0 || $('.pdp-mobile-auth').attr('data-mobileauth-enabled') !== 'true' || $('.pdp-mobile-auth').attr('data-mobileauth-pending') !== 'true')) {
            var urlParams = new URLSearchParams(window.location.search);
            var wlColor = urlParams.get('wl_color');
            var wlSize = urlParams.get('wl_size');
            var wlLength = urlParams.get('wl_length');
            var wlSize1 = urlParams.get('wl_size1');
            var wlSize2 = urlParams.get('wl_size2');

            if (!wlColor && !wlSize && !wlLength && !wlSize1) {
                return;
            }

            const self = this;
            const $el = this.$el;

            /**
             * Removes the wl_ params from the URL after the variations have
             * been restored.
             */
            var cleanupUrl = function () {
                urlParams.delete('wl_color');
                urlParams.delete('wl_size');
                urlParams.delete('wl_length');
                urlParams.delete('wl_size1');
                urlParams.delete('wl_size2');
                var hash = '';
                if (window.location.href.indexOf('#') !== -1) {
                    hash = '#' + window.location.href.split('#')[1];
                }
                var url = window.location.pathname + '?' + urlParams.toString() + hash;
                history.replaceState({}, '', url);
            };

            /**
             * Builds the arguments for a colour selection, or returns null
             * when the saved colour is not selectable on this page.
             *
             * @returns {Object|null} attributeSelect arguments
             */
            var colorStep = function () {
                if (!wlColor) {
                    return null;
                }
                var $swatch = $('.b-product_attrs-item[data-attr="color"] ul li a[data-attr-value="' + wlColor + '"]');
                if (!$swatch.length || $swatch.hasClass('m-active')) {
                    return null;
                }
                var valueUrl = $swatch.closest('li').attr('data-url');
                if (!valueUrl) {
                    return null;
                }
                return {
                    option: 'color',
                    value: wlColor,
                    valueUrl: valueUrl
                };
            };

            /**
             * Builds the arguments for the split-size selection. Both halves
             * go in one request, which is how `onSelectSize` submits them, so
             * there is no intermediate state to wait on.
             *
             * The lookup is read at call time rather than up front because a
             * colour selection replaces the `.sizeSplit` element along with
             * its `data-split-lookup`, and the sizes available for the
             * restored colour are the ones in the replacement.
             *
             * @returns {Object|null} attributeSelect arguments
             */
            var splitSizeStep = function () {
                if (!wlSize1 || !wlSize2) {
                    return null;
                }
                var $splitContainer = $('.sizeSplit', $el);
                if (!$splitContainer.length) {
                    return null;
                }
                var lookup;
                try {
                    lookup = JSON.parse($splitContainer.attr('data-split-lookup'));
                } catch (e) {
                    return null;
                }
                if (!lookup || !lookup.first || !lookup.first[wlSize1] || !lookup.first[wlSize1][wlSize2]) {
                    return null;
                }
                return {
                    option: 'size',
                    value: lookup.first[wlSize1][wlSize2].value,
                    valueUrl: lookup.first[wlSize1][wlSize2].url,
                    splitValues: { first: wlSize1, second: wlSize2 }
                };
            };

            /**
             * Builds the arguments for a plain size or length selection, or
             * returns null when the value has no swatch in the current DOM.
             *
             * @param {string} attrName - 'size' or 'length'
             * @param {string} value - the data-attr-value to find
             * @returns {Object|null} attributeSelect arguments
             */
            var nonColorStep = function (attrName, value) {
                if (!value) {
                    return null;
                }
                var $container = $('.b-product_attrs-item[data-attr="' + attrName + '"]');
                if (!$container.length) {
                    return null;
                }
                var $swatch = $container.find('ul li a[data-attr-value="' + value + '"]');
                if (!$swatch.length) {
                    return null;
                }
                // An already-selected swatch carries a deselect URL: the value
                // of its own dwvar_* parameter is empty. Posting it unselects
                // the attribute instead of restoring it, which is how a
                // length that the server had already defaulted to "Regular"
                // ended up cleared (SFCC-7482). onSizeChange guards the same
                // way before acting on a click.
                if ($swatch.hasClass('m-active') || $swatch.hasClass('selected')) {
                    return null;
                }
                var valueUrl = $swatch.closest('li').attr('data-url');
                if (!valueUrl) {
                    return null;
                }
                // A length change drops the size, matching onSizeChange: the
                // size currently in the URL may not be offered in the new
                // length, and the server would then resolve nothing.
                if (attrName === 'length') {
                    valueUrl = self.removeSizeParameterFromUrl(valueUrl);
                }
                return {
                    option: attrName,
                    value: value,
                    valueUrl: valueUrl
                };
            };

            // The steps run one at a time, each from the previous step's
            // `product:afterAttributeSelect`. Two reasons they cannot be
            // issued together: selecting one attribute replaces the swatch
            // markup for the others, so a later synchronous call would read
            // detached nodes and send a stale URL; and the sizes a colour
            // offers are only in the DOM once that colour's response has
            // rendered. A product carrying both a size and a length needs both
            // steps to run, which is why the queue continues rather than
            // stopping at the first success.
            //
            // A step that resolves to null is skipped, not fatal: the saved
            // value may not exist for the restored colour, or it is already
            // selected, and restoring what can be restored beats abandoning
            // the rest.
            //
            // Length comes before any size. A length change has to drop the
            // size from its URL (see nonColorStep), so running it later would
            // discard the size that was just restored, whereas the size
            // swatches rendered after a length change already carry that
            // length, so both survive in this order.
            var steps = [colorStep, function () {
                return nonColorStep('length', wlLength);
            }, splitSizeStep];

            // A split-size product records its halves, not a plain size, and
            // its two containers both carry `data-attr="size"`. Queueing the
            // plain size step for one would match those containers and select
            // the size a second time, undoing the split selection.
            if (!wlSize1) {
                steps.push(function () {
                    return nonColorStep('size', wlSize);
                });
            }

            /**
             * Runs the remaining steps in order, then clears the URL.
             *
             * Cleanup runs on every path, success included. Leaving the
             * parameters behind would reapply this saved selection on the next
             * reload, overriding whatever the customer picked in between.
             *
             * The listener filters on `source: 'wishlistRestore'` so only
             * this queue's own responses advance it. The event is global, and
             * prepopulateSize and initSizeSplits both select attributes from
             * init(), one of them behind an extra round trip, so either can
             * still be in flight when this runs on window load. An
             * unfiltered listener mistakes their response for the step's own
             * and advances a step early.
             *
             * @param {number} index - the step to attempt
             * @returns {void}
             */
            var runStep = function (index) {
                if (index >= steps.length) {
                    cleanupUrl();
                    return;
                }

                var args = steps[index]();

                if (!args) {
                    runStep(index + 1);
                    return;
                }

                var handler = function (e, response) {
                    if (!response || response.source !== 'wishlistRestore') {
                        return;
                    }
                    self.$body.off('product:afterAttributeSelect', handler);
                    runStep(index + 1);
                };

                self.$body.on('product:afterAttributeSelect', handler);
                self.attributeSelect($.extend({}, args, { source: 'wishlistRestore' }));
            };

            runStep(0);
        }
    }

    /*
     * The gallery markup is only emitted while the enablePDPGallery site preference is on.
     *
     * @returns {boolean} true when the gallery is on the page
     */
    hasPdpGallery() {
        return $('.js-pdp-gallery', this.$el).length > 0;
    }

    /**
     * Leaves the image column free to resize.
     */
    updateMinHeightPdpImage() {
        if (!this.hasPdpGallery()) {
            super.updateMinHeightPdpImage();
        }
    }

    /**
     * Rebuilds the gallery around the image set from the variation response.
     *
     * Core rebuilds the main slides from image.url alone, so image.thumbURL never reaches the
     * DOM and the thumbnail rail cannot be derived from it after a colour or fit-model change.
     *
     * @param {Object} option - the attribute the customer changed
     * @param {Object} response - Product-Variation response
     */
    handleVariantResponse(option, response) {
        var images = response && response.product ? response.product.images : null;
        var updatesGallery = this.hasPdpGallery()
            && option && option.option === 'color'
            && images && images.pdpMainDesktop && images.pdpMainDesktop.length > 0;

        // Swiper has to let go of the slides before core replaces the wrapper markup. Its loop
        // teardown re-runs slideTo() against whatever it finds in the wrapper, which lands on a
        // slide that no longer exists when the incoming size has fewer photos than the old one.
        if (updatesGallery) {
            $('.js-main-image-carousel', this.$el).trigger('pdpGallery:teardown');
        }

        super.handleVariantResponse(option, response);

        if (updatesGallery) {
            this.restore360DegreeVideo(response);
            $('.js-main-image-carousel', this.$el).trigger('pdpGallery:update', [images.pdpMainDesktop]);
        }
    }

    /**
     * Puts the 360 video slide back after a colour change.
     *
     * @param {Object} response - Product-Variation response
     */
    restore360DegreeVideo(response) {
        var video360Material = response.product.video360Material;

        if (!video360Material || video360Material.length === 0) {
            return;
        }

        this.update360DegreeVideo(
            video360Material,
            response.isShopThisOutfitEnabled && response.product.custom.enableShopTheLook
        );
    }

    /**
     * Returns the image index currently shown in the gallery.
     *
     * Swiper's loop mode reorders slides in the DOM, so the zoom modal has to be opened from the
     * slide's data-index instead of its DOM position. The 360 video slide carries no data-index
     * and falls back to the first photo.
     *
     * @returns {string} index of the displayed image
     */
    getActiveGalleryIndex() {
        var index = $('.js-main-image-carousel .js-product_carousel-slide.swiper-slide-active', this.$el).attr('data-index');

        return typeof index === 'undefined' ? '0' : index;
    }

    /**
     * The gallery arrows and pagination dots sit inside .js-pdp-open-zoommodal, which core
     * delegates the "open zoom modal" click to, so navigating the carousel would also open the
     * modal. Clicks that start on a Swiper control belong to the carousel only.
     *
     * @param {jQuery.Event} event - click event
     * @returns {boolean} true when the click targets a carousel control
     */
    isGalleryControlClick(event) {
        return $(event.target).closest('.b-product_carousel-control, .b-product_carousel-pagination').length > 0;
    }

    productGalleryIndexMobile(event) {
        if (!this.hasPdpGallery()) {
            super.productGalleryIndexMobile(event);
            return;
        }

        if (this.isGalleryControlClick(event)) {
            return;
        }

        if ($(window).width() < 1024 && !$(event.target).hasClass('js-shop-this-outfit')) {
            event.preventDefault();
            $('#productZoomModal', this.$el).attr('data-navigate', this.getActiveGalleryIndex());
            $('body').find('.zoomImageCount').trigger('click');
        }
    }

    productPdpZoomModal(event) {
        if (!this.hasPdpGallery()) {
            super.productPdpZoomModal(event);
            return;
        }

        if (this.isGalleryControlClick(event)) {
            return;
        }

        if (!$(event.target).hasClass('js-shop-this-outfit') && $(window).width() >= 1024) {
            event.preventDefault();
            $('#productZoomModal', this.$el).attr('data-navigate', this.getActiveGalleryIndex());
            $('body').find('.zoomImageCount').trigger('click');
            $('body').trigger('modalShown', {
                name: 'product: gallery zoom'
            });
        }
    }

    onupdateAddToCartModal(e, responseData) {
        var url = $('.added-tocart-confirmation-modal-url').val();
        var form = {};
        form = {
            pid: $('.l-pdp.product-detail').data('pid'),
            qty: $('.js-quantity-select').val()
        };
        var lineItem = responseData.cart.items.find(item => responseData.pliUUID === item.UUID);
        form.isPersonalizationEligible = lineItem.isPersonalizationEligible;
        if (lineItem.isPersonalizationEligible) {
            form.personalizationDetail = lineItem.personalizationDetail;
            form.optionalItemPrice = lineItem.priceTotal.optionalItemPrice;
        }
        if ($('.js-cmp-productDetail form.e-giftcard').length) {
            var amount = $('.js-cmp-productDetail form.e-giftcard').find('.js-giftcard-amount').val();
            form.gcAmount = parseFloat(amount).toFixed(2);
        }
        if ($('.b-size_pdp .b-select-size-outer ul li a.selected').length > 0 && $('.b-size_pdp .b-select-size-outer ul li a.selected').attr('data-size-attr')) {
            form.gcAmount = $('.b-size_pdp .b-select-size-outer ul li a.selected').attr('data-size-attr');
        }
        $.spinner().start();
        if (url) {
            $.ajax({
                url: url,
                type: 'get',
                data: form,
                success: function (response) {
                    $('#cartConfirmationModal .js-product-detailsConfirmation').html(response);
                    $('#cartConfirmationModal').modal('show');
                    if ($('.b-add-to-cart-confirmation-modal-container').data('giftcard') === true) {
                        $('.b-cart-added-confirmation-modal').find('.b-cart-content-recommendation').hide();
                        $('#cartConfirmationModal .js-product-detailsConfirmation').addClass('eGiftcard-Added');
                    }
                    $('.js-confirmation-modal-recommendation-tiles').removeClass('hide');
                    $('.b-cart-added-confirmation-modal').find('.product-listing').trigger('mainCarousel:update');
                    $.spinner().stop();
                    setTimeout(function () {
                        $('body').trigger('components:init');
                    }, 500);
                },
                error: function (err) {
                    console.log(err);
                }
            });
        }
    }

    displayEarlyAccessErrorModal(content) {
        var $modal = $('#nonEACustomerModal');
        $modal.find('.early-access-modal-container').html(content);
        $('#nonEACustomerModal').modal('show');
    }

    onAddToCart(event) {
        var addToCartUrl;
        var pidsObj;
        var setPids;
        var requiredSelections = ['color', 'length', 'size', 'amount'];

        if ($('.b-add_to_bag .js-add-to-cart', this.$el).attr('exclusive-oos') === 'true') {
            return;
        }

        var $target;
        if (event !== undefined) {
            $target = $(event.target);
            if ($target.hasClass('js-update-cart-product-global js-add-to-cart')) {
                return;
            }
        }

        if (savedItem || productId !== this.$el.data('pid')) {
            $('.b-add_to_bag', this.$el).spinner().start();
            $('.b-add_to_bag .js-add-to-cart', this.$el).html('');
            $('.b-add_to_bag .js-egiftcard-add-to-cart', this.$el).html('');
            this.$el.trigger('product:beforeAddToCart', this.$addToCartButton);

            if ($('.set-items').length && this.$addToCartButton.hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail', this.$el).each(function () {
                    if (!this.$addToCartButton.hasClass('product-set-detail')) {
                        setPids.push({
                            pid: this.$addToCartButton.find('.product-id').text(),
                            qty: this.$addToCartButton.find('.js-quantity-select').val(),
                            options: this.getOptions(this.$addToCartButton)
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            addToCartUrl = this.getAddToCartUrl($target);
            var form;
            if (event !== undefined && event.currentTarget.closest('.b-cart-btn_savelater') !== null) {
                savedItem = false;
                productId = this.$el.data('pid');
                form = {
                    pid: this.$el.data('pid'),
                    pidsObj: pidsObj,
                    childProducts: this.getChildProducts(),
                    quantity: 1
                };
            } else {
                form = {
                    pid: this.$el.data('pid'),
                    pidsObj: pidsObj,
                    childProducts: this.getChildProducts(),
                    quantity: this.getQuantitySelected(this.$addToCartButton) || 1
                };
                if (window.memberPriceATC) {
                    delete window.memberPriceATC;
                    form.memberPriceATC = true;
                }
            }

            if (!$('.bundle-item', this.$el).length) {
                form.options = this.getOptions();
            }

            if ($('input[type="hidden"][name="personalizationName"]').length > 0) form.personalizationName = $('input[name="personalizationName"]').val();
            if ($('input[type="hidden"][name="personalizationNumber"]').length > 0) form.personalizationNumber = $('input[name="personalizationNumber"]').val();
            if ($('input[type="hidden"][name="personalizationSponsors"]').length > 0) form.personalizationSponsors = $('input[name="personalizationSponsors"]').val();

            var eGiftCardFormData = {};
            if (this.$eGiftCardForm.length > 0) {
                var eGiftCardData = this.$eGiftCardForm.serializeArray();
                eGiftCardData.forEach(function (data) {
                    eGiftCardFormData[data.name] = data.value;
                });
                form.eGiftCardData = JSON.stringify(eGiftCardFormData);
            } else if (this.$el.find('.b-cart-btn_savelater').length > 0 && this.$el.find('.gcamount').length > 0) {
                eGiftCardFormData.gcRecipientName = this.$el.find('p.t-lineitem_attributes.gcrecipientname').data('gcrecipientname');
                eGiftCardFormData.gcRecipientEmail = this.$el.find('p.t-lineitem_attributes.gcrecipientemail').data('gcrecipientemail');
                eGiftCardFormData.gcFrom = this.$el.find('p.t-lineitem_attributes.gcfrom').data('gcfrom');
                eGiftCardFormData.gcDeliveryDate = this.$el.find('p.t-lineitem_attributes.gcdeliverydate').data('gcdeliverydate');
                eGiftCardFormData.gcMessage = this.$el.find('.gcmessage').data('gcmessage');
                eGiftCardFormData.gcAmount = this.$el.find('.gcamount').data('gcamount');
                form.eGiftCardData = JSON.stringify(eGiftCardFormData);
            }

            this.$addToCartButton.trigger('updateAddToCartFormData', form);
            $('.error-message-text').empty();
            const self = this;
            if (addToCartUrl) {
                var missingSelection = [];
                $.each(requiredSelections, function (index, attributeKey) {
                    var attribute = self.$attrsContainer.find('.b-product_attrs-item[data-attr="' + attributeKey + '"]');
                    if (self.config && self.config.cmp === 'productQuickView') {
                        attribute = self.$attrsContainer.find('.b-product_qvattrs-item[data-attr="' + attributeKey + '"]');
                        attribute.find('.selected.disabled').addClass('m-active');
                    }
                    var attributesToCheck = attribute;
                    if (attributeKey === 'size' && attribute.closest('.sizeSplit').length) {
                        attributesToCheck = attribute.closest('.sizeSplit').find('.b-product_attrs-item.variation_attr');
                    }
                    attributesToCheck.each(function () {
                        var $attr = $(this);

                        if ($attr.length) {
                            if ($attr.find('.m-active').length === 0 && $attr.find('.selected').length === 0) {
                                missingSelection.push(attributeKey);
                                $attr.addClass('has-error');
                                if ($attr.find('.invalid-feedback').length) {
                                    $attr.find('.invalid-feedback').show();
                                } else {
                                    $attr.append('<div class="invalid-feedback">' + $attr.data('error-label') + '</div>');
                                }
                                $('body').trigger('addtobag:error', { errorMsg: $attr.data('error-label') });
                                if (!isVisible($attr)) {
                                    scrollAnimate($attr);
                                }
                            } else if ($attr.find('.m-active.disabled').length && $attr.find('.selected.disabled').length) {
                                missingSelection.push(attributeKey);
                                var oosMsg = $attr.find('.m-' + $attr.data('attr')).data('error-message-label');
                                if ($attr.find('.selection-error-message').length) {
                                    $attr.find('.selection-error-message').show();
                                } else if (self.config && self.config.cmp === 'productQuickView') {
                                    $attr.find('.b-product_attribute').append('<div class="selection-error-message">' + oosMsg + '</div>');
                                } else {
                                    $attr.append('<div class="selection-error-message">' + oosMsg + '</div>');
                                }
                                $('body').trigger('addtobag:error', {
                                    errorMsg: oosMsg
                                });
                            } else {
                                $attr.removeClass('has-error');
                                $attr.find('.invalid-feedback').hide();
                                $attr.find('.selection-error-message').hide();
                            }
                        }
                    });
                });
                if (missingSelection.length === 0) {
                    var dateExceeded = $(this.$el).find('.earlierdate').val();
                    var egcUrl = $(this.$el).find('.js-add-to-cart').data('egc-editurl');
                    var isTrueSet = (dateExceeded === 'true');
                    if ((this.$el.hasClass('egiftcardlineitem') || this.$el.hasClass('cart-savelater-product')) && isTrueSet) {
                        $('.eGCModal').modal('show');
                        $('.eGCModal').find('.js-edit-saveforlater').attr('href', egcUrl);
                        savedItem = true;
                        $.spinner().stop();
                        $('.b-add_to_bag').spinner().stop();
                        $('.js-add-to-cart').text($('.js-add-to-cart').data('addto-bag'));
                    } else {
                        $.ajax({
                            url: addToCartUrl,
                            method: 'POST',
                            data: form,
                            context: this,
                            success: this.onSuccessAddToCart.bind(this),
                            error: function () {
                                $.spinner().stop();
                                $('.js-add-to-cart').text($('.js-add-to-cart').data('has-error'));
                            }
                        }).then(this.deselectAmountSwatch());
                        if (event) {
                            event.stopPropagation();
                        }
                    }
                    // }
                } else {
                    $.spinner().stop();
                    $('.b-add_to_bag').spinner().stop();
                    if ($('.js-add-to-cart').hasClass('js-unlock-access')) {
                        $('.js-add-to-cart').text($('.js-add-to-cart').data('unlock-access'));
                    } else {
                        $('.js-add-to-cart').text($('.js-add-to-cart').data('addto-bag'));
                    }
                }
            }
        }
    }

    // Move this function to APAC to update the E-giftcard add to bag button after prodcut added to cart for APAC site Only.
    onSuccessAddToCart(data) {
        if (data && data.uarExclusive) {
            var event = 'uarexclusive:' + data.uarExclusive;
            $('body').trigger(event, {
                pid: $('.l-pdp.product-detail').data('pid'),
                uarExclusivePopup: data.uarExclusivePopup
            });
            $('.b-add_to_bag', this.$el).spinner().stop();
            if (data.uarExclusive === 'guestpopup') {
                $('.js-add-to-cart', this.$el).text($('.js-add-to-cart').data('unlock-access'));
            } else {
                $('.js-add-to-cart', this.$el).text($('.js-add-to-cart').data('addto-bag'));
            }
            return;
        }
        this.handlePostCartAdd(data);
        var addedToCart = $('.js-add-to-cart, .js-egiftcard-add-to-cart', this.$el).data('added-msg');
        var addAnother = $('.js-add-to-cart, .js-egiftcard-add-to-cart', this.$el).data('add-another');
        var addToBagMsg = $('.js-add-to-cart, .js-egiftcard-add-to-cart').data('addto-bag');
        var hasError = $('.js-add-to-cart, .js-egiftcard-add-to-cart', this.$el).data('has-error') || addToBagMsg;
        var resetQuantity = true;

        if ($('.b-cart-content.cart').length > 0) {
            if (data && data.savedItemAvailabilityError) {
                $('.availability-err', this.$el).removeClass('hide');
                $.spinner().stop();
                $('.b-add_to_bag', this.$el).spinner().stop();
                $('.js-add-to-cart', this.$el).text(addToBagMsg);
                return;
            }

            if (data && data.cart.freeShippingBar) {
                freeShippingBar.methods.updateShippingBar(data.cart.freeShippingBar);
                freeShippingBar.methods.getShippingPromo(data.cart.totals);
            }

            if (!this.$el.hasClass('product-recommendation-quickview')) {
                this.onAddToCartRemoveSaveFromLater(data);
                if (data.cart.hasPreOrder) {
                    $('.js_paypal_button').addClass('hide');
                    $('.js_paypal_button', this.$el).parents('.b-product_actions-inner').addClass('btn-align-mobile');
                } else {
                    $('.js_paypal_button').removeClass('hide');
                    $('.js_paypal_button', this.$el).parents('.b-product_actions-inner').removeClass('btn-align-mobile');
                }
            } else if (data.renderedTemplate) {
                this.$body.trigger('cart:updateCartTotals', [data.cart, this]);
                if ($('.cart').find('.b-cartlineitem').length === 0) {
                    window.location.reload();
                } else {
                    // update cart product cards markup
                    $('.js-cart-items').replaceWith(data.renderedTemplate);
                    // set quantity select values for new product cards
                    Array.from($('.b-cart-content .b-cartlineitem .b-quantity-select')).map(function (select) {
                        $(select).val(parseInt($(select).data().preSelectQty, 10));
                        return select.value;
                    });
                    resetQuantity = false;
                    $('body').trigger('cart:update');
                }
            }
            if ((data.cart.hasGiftCards || data.cart.hasPreOrder) && $('.b-cart_klarna-placement').length > 0) {
                $('.b-cart_klarna-placement').addClass('hide');
            } else {
                $('.b-cart_klarna-placement').removeClass('hide');
            }
        }
        var srContainer = $('.b-cart-content_right .b-cart_shoprunner').closest('div');
        if (data.cart && data.cart.srEligible && srContainer.hasClass('hide')) {
            srContainer.removeClass('hide');
        }
        var analyticsData = {
            analytics: {
                isWishlist: true,
                quantityAdded: this.getQuantitySelected(this.$addToCartButton) || 1,
                isQuickAdd: this.$addToCartButton.closest('.quick-add-dialog, .js-tile-quickAdd_buttonn').length > 0
            }
        };
        $('body').trigger('product:afterAddToCart', $.extend(data, analyticsData));
        this.afterAddToCart();
        $.spinner().stop();
        $('.b-add_to_bag').spinner().stop();
        if (!data.error) {
            this.$el.find('.js-add-to-cart, .js-egiftcard-add-to-cart').addClass('f-added-check').html(addedToCart);
            var self = this;
            setTimeout(function () {
                self.$el.find('.js-add-to-cart.f-added-check, .js-egiftcard-add-to-cart.f-added-check').removeClass('f-added-check').html(addAnother);
            }, 5000);
            if (resetQuantity) {
                const resetDelay = 3000;

                setTimeout(() => {
                    if (this.$el.length && this.$el.is(':visible')) {
                        var $qtySelect = $('.js-quantity-select', this.$el);
                        $qtySelect.find('option:selected').removeAttr('selected');
                        $qtySelect.val($('.js-quantity-select option:first').attr('selected', 'selected').val());
                        if ($('.b-cart-content.cart').length === 0) {
                            $qtySelect.trigger('change');
                        }
                    }
                    // Revert button text to 'Add To Bag' once product successfully added to bag[E-GiftCard].
                    if (this.$eGiftCardForm.length > 0) {
                        $('.js-egiftcard-add-to-cart').removeClass('f-added-check').html(addToBagMsg);
                    }
                }, resetDelay);
            }
        } else {
            this.$el.find('.js-add-to-cart, .js-egiftcard-add-to-cart').html(hasError);
        }
    }

    afterAddToCart() {
        // Clear eGift Card form
        if (this.$eGiftCardForm.length > 0) {
            this.$eGiftCardForm[0].reset();
            $('.js-egiftcard-add-to-cart').text($('.js-egiftcard-add-to-cart').data('addto-bag'));
        }
    }

    getOptions() {
        var options = this.$el.find('.product-option')
            .map((index, option) => {
                var $elOption = $(option).find('.options-select');
                var urlValue = $elOption.val();
                var selectedValueId = $elOption.find('option[value="' + urlValue + '"]')
                    .data('value-id');
                return {
                    optionId: $(option).data('option-id'),
                    selectedValueId: selectedValueId
                };
            }).toArray();

        return JSON.stringify(options);
    }
}
